import { BaseModel } from "../../core/src/model/BaseModel"
import IFreeGamesData from "./IFreeGamesData";

class PromotionalFreeGamesModel extends BaseModel<IFreeGamesData> {
    public offerId: string = "";
    public currentBetMultiplier: number = 0;
    public coinSize: number = 0;
    public totalBet: number = 0;
    public instanceId: string = "";
    public sumWinnings: string = "";
    public freeGamesCount: number = 0;
    public gamesPlayed: number = 0;
    public gamesAwarded: number = 0;
    protected inFreeGames: boolean = false;

    public hasPromotion(): boolean {
        return this.offerId.length > 0;
    }

    public isInFreeGames() {
        return this.inFreeGames;
    }

    public enterFreeGames() {
        this.inFreeGames = true;
    }

    public exitFreeGames() {
        this.inFreeGames = false;
        this.cleanup();
    }

    public cleanup() {
        this.offerId = "";
        this.currentBetMultiplier = 0;
        this.coinSize = 0;
        this.totalBet = 0;
        this.instanceId = "";
        this.sumWinnings = "";
        this.freeGamesCount = 0;
        this.gamesPlayed = 0;
        this.gamesAwarded = 0;
    }
}

export default new PromotionalFreeGamesModel();